import './env-ribbon.css';

export const envRibbon = {
    template: `
        <div ng-show="$ctrl.envNameKey" class="ribbon">
            <a href="" translate="{{$ctrl.envNameKey}}"></a>
        </div>
    `,

    controller: class RibbonController {
        $onInit() {
            const host = window.location.hostname;
            var ctrl = this;

            // En prod on affiche rien
            if (host === 'bo.sybycegedim.com' || host === 'portal.sybycegedim.com') {
                ctrl.envNameKey = null;
                return;
            }

            // On récupère la partie avant le 1er point
            const prefix = host.split('.')[0];

            const mapping = {
                dev: 'environment.integration',
                'test-qas': 'environment.qas',
                'test-qat': 'environment.qa',
                test2: 'environment.testing',
                test: 'environment.preprod',
                'integration-bo': 'environment.integration',
                'qas-bo': 'environment.qas',
                'qa-bo': 'environment.qa',
                'testing-bo': 'environment.testing',
                'preprod-bo': 'environment.preprod',
            };

            ctrl.envNameKey = mapping[prefix] || null;
        }
    },
};
